import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractFilterComponent } from './abstract-filter.component';
import { FilterClearButtonComponent } from '../filter-clear-button.component';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatFormField, MatLabel } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { I18nProviderInjectionToken } from '@pct-ng/i18n';
import { MatSuffix } from '@angular/material/form-field';
import type { MaybeArray } from 'date-fns';
import { type LanguageCode, LanguageCodes } from '../../../model/language-code';

@Component({
  selector: 'cappus-filter-language',
  imports: [
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    FilterClearButtonComponent,
    ReactiveFormsModule,
    TranslocoPipe,
    MatSuffix,
  ],
  templateUrl: './filter-language.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterLanguageComponent extends AbstractFilterComponent<MaybeArray<LanguageCode> | null> {
  protected readonly coreI18nScope = `${I18nProviderInjectionToken.scope}.`;
  protected readonly LanguageCodes = LanguageCodes;
}
